import {
  TeacherListApi,
  ClassesTeacherListApi,
  ClassesStudentListApi,
  classListApi,
  StudentListAPi,
  getScheduleEventApi,
  getCancelSchedulerApi,
  getRoomSchedulerApi,
  roomListApi,
  getClassShortList,
  changeUserColor
} from '@/api/schedulerApi.js'
import { fetchUserClient } from '@/api/task-project.js'

import moment from 'moment'
import {getCourseWithTeacher} from '@/api/attendance'
import {getClassListWithoutPagination} from '@/api/classes'
import {mapGetters} from 'vuex'

export const eventMixin = {
  data () {
    return {
      counter :0,
      dateRange:{},
      client_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      events: [],
      id: null,
      groupId: null,
      allDay: null,
      start: null,
      end: null,
      title: null,
      url: null,
      color: null,
      backgroundColor: null,
      borderColor: null,
      textColor: null,
      eventGuid:0,
      teacherList:[],
      roomList: [],
      studentList:[],
      courseList:[],
      roomClassList: [],
      class_list: [],
      course_filter_id:[],
      class_filter_id: [],
      room_course_filter_id:[],
      room_class_filter_id: [],
      filter_payload: {
        class:true,
        course:true,
        canceled:true
      }
    }
  },
  computed: {
    ...mapGetters(['get_localization_setting'])
  },
  watch:{
    counter () {

    },
    get_localization_setting:{
      immediate:true,
      deep:true,
      handler () {
        if (this.get_localization_setting) {
          this.calendarOptions.firstDay = this.get_localization_setting.start_day_id

        }
      }
    },
    course_filter_id:{
      deep:true,
      handler () {
        this.fetchingTeacherList({course_id:this.course_filter_id}, 'true')
      }
    },
    // course_filter_id:{
    //   deep:true,
    //   handler () {

    //     this.fetchingStudentList(this.course_filter_id, 'true')
    //   }
    // },
    class_filter_id: {}
  },
  methods: {
    async checkColor (color_code) {
      this.activeColorIndex = null
      this.presetColors.forEach((ele, index) => {
        if (ele === color_code) {
          this.activeColorIndex = index
        }
      })
    },
    async saveColorUser (user_id, index) {
      const payload = {
        user_id,
        colour_code:this.colour_code
      }
      await changeUserColor(localStorage.getItem('customer_id'), payload)
      this.active_user_index = null
      this.teacherList[index].colour_code = this.colour_code
      //this.fetchingTeacherList()
      const payloadData = {...this.creatingPayload('teacher'), course_id:this.course_filter_id, ...this.filter_payload}
      this.fetchingEvent(payloadData, 'teacher')

    },
    testing () {

    },
    createEventId () {
      return String(this.eventGuid++)
    },
    setEvent () {
      this.events.push({
        id: null,
        groupId: null,
        allDay: true,
        start: null,
        end: null,
        title: null,
        url: null,
        color: null,
        backgroundColor: null,
        borderColor: null,
        textColor: null
      })
    },
    addNewEvent () {},
    editNewEvent () {},
    removeNewEvent () {
      const calendarApi = this.$refs.fullCalendar.getApi()
      const event = calendarApi.getEventById(4)
      event.remove()
    },
    schedulingListSetData (events, type) {

      if (type === 'teacher_classes' || type === 'student_classes') {
        return events.map(ele => {

          return {
            id : ele.id,
            title: ele.class ? ele.class.name : '',
            description: ele.class ? ele.class.description : '',
            start : `${moment(ele.schedule_date).format('YYYY-MM-DD')} ${ele.schedule_from_time ? ele.schedule_from_time : ''}`,
            end : `${moment(ele.schedule_date).format('YYYY-MM-DD')} ${ele.schedule_to_time ? ele.schedule_to_time : ''}`,
            backgroundColor : ele.colour_code ? ele.colour_code : 'red',
            location : '',
            eventTypePicked : '',
            userId: ele.user_id,
            class: ele
          }
        })
      } else if (type === 'room') {
        return events.map(ele => {
          return {
            id : ele.id,
            title : ele.course ? ele.course.name : '',
            classTitle: ele.class ? ele.class.name : '',
            description:ele.course ? ele.course.description : '',
            start : `${moment(ele.schedule_date).format('YYYY-MM-DD')} ${ele.schedule_from_time ? ele.schedule_from_time : ''}`,
            end : `${moment(ele.schedule_date).format('YYYY-MM-DD')} ${ele.schedule_to_time ? ele.schedule_to_time : ''}`,
            backgroundColor : ele.colour_code ? ele.colour_code : 'red',
            location : '',
            eventTypePicked : '',
            userId:ele.user_id,
            course:ele
          }
        })
      } else {
        return events.map(ele => {
          return {
            id : ele.id,
            title : ele.course ? ele.course.name : '',
            description:ele.course ? ele.course.description : '',
            start : `${moment(ele.schedule_date).format('YYYY-MM-DD')} ${ele.schedule_from_time ? ele.schedule_from_time : ''}`,
            end : `${moment(ele.schedule_date).format('YYYY-MM-DD')} ${ele.schedule_to_time ? ele.schedule_to_time : ''}`,
            backgroundColor : ele.colour_code ? ele.colour_code : 'red',
            location : '',
            eventTypePicked : '',
            userId:ele.user_id,
            course:ele
          }
        })
      }
    },
    schedulingListGeneralSetData (events) {
      return events.map(ele => {

        return {
          id : ele.id,
          title : ele.title,
          start : `${moment((ele.schedule_date)).format('YYYY-MM-DD')} ${ele.schedule_from_time ? ele.schedule_from_time : '00:00'}`,
          end : `${moment((ele.schedule_date)).format('YYYY-MM-DD')} ${ele.schedule_to_time ? ele.schedule_to_time : '00:00'}`,
          startTiming:ele.schedule_from_time,
          endTiming:ele.schedule_to_time,
          backgroundColor : ele.colour_code,
          location : ele.location,
          eventTypePicked : '',
          userId:ele.user_id,
          description:ele.description,
          allDay:ele.all_day_event,
          user_participants:ele.user_participants,
          client_participants:ele.client_participants


        }
      })
    },
    async fetchingTeacherList (payload = {}, checkingChanges = false) {
      const customer_id = this.$store.getters.customerId
      const responseTeacher = await fetchUserClient(
        'User',
        customer_id,
        {},
        {...payload, paginate:false}
      )
      const isActive = this.allTeachers
      this.teacherList = responseTeacher.data.data.users_list.map(function (el) {
        const newObject = Object.assign({}, el)
        newObject.isActive = isActive
        return newObject
      })

      this.client_meta =  responseTeacher.data.data.meta
      // this.client_meta.page =  responseTeacher.data.data.meta.current_page
      if (checkingChanges) {
        this.filterTeacherEvent()
      }

    },
    async loadMoreTeacher (payload = [], checkingChanges = false) {
      const customer_id = this.$store.getters.customerId
      this.client_meta.page = this.client_meta.page + 1
      const responseTeacher = await fetchUserClient(
        'User',
        customer_id,
        this.client_meta
      )
      const isActive = this.allTeachers
      const teachers = responseTeacher.data.data.users_list.map(function (el) {
        const newObject = Object.assign({}, el)
        newObject.isActive = isActive
        return newObject
      })
      this.teacherList = [...this.teacherList, ...teachers]
      this.client_meta = responseTeacher.data.data.meta
      this.client_meta.page =  responseTeacher.data.data.meta.current_page
      if (checkingChanges) {
        this.filterTeacherEvent()
      }

    },
    async detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight  &&  this.client_meta.has_next
      ) {
        this.loadMoreTeacher()
      }
    },


    async fetchingClassesTeacherList (payload = [], checkingChanges = false) {
      const customer_id = this.$store.getters.customerId
      const requestPayloadData = {
        class_id:payload
      }
      const responseTeacher = await ClassesTeacherListApi(customer_id, requestPayloadData)
      this.teacherList = responseTeacher.data.data.teacherlist.map(function (el) {
        const newObject = Object.assign({}, el)
        newObject.isActive = true
        return newObject
      })
      if (checkingChanges) {
        this.filterClassesTeacherEvent()
      }

    },

    async roomListApi (coursePayload = [], classPayload = [], checkingChanges = false) {
      const customerId = this.$store.getters.customerId
      const requestPayloadData = {
        // page:1,
        // perPage:200
        customer_id: customerId,
        class_id: classPayload,
        course_id: coursePayload
      }
      const responseRoom = await roomListApi(requestPayloadData)
      this.roomList = responseRoom.data.data.list.map(function (el) {
        const newObject = Object.assign({}, el)
        newObject.isActive = true
        return newObject
      })
      if (checkingChanges) {
        this.filterRoomEvent()
      }

    },

    async fetchingStudentList (payload = [], checkingChanges = false) {
      const customer_id = this.$store.getters.customerId
      const requestPayloadData = {
        course_id:payload
      }
      const responseTeacher = await StudentListAPi(customer_id, requestPayloadData)
      this.studentList = responseTeacher.data.data.studentlist.map(function (el) {
        const newObject = Object.assign({}, el)
        newObject.isActive = true
        return newObject
      })

      if (checkingChanges) {
        this.filterStudentEvent()
      }

    },

    async fetchingClassesStudentList (payload = [], checkingChanges = false) {
      const customer_id = this.$store.getters.customerId
      const requestPayloadData = {
        class_id:payload
      }
      const responseTeacher = await ClassesStudentListApi(customer_id, requestPayloadData)
      this.studentList = responseTeacher.data.data.studentlist.map(function (el) {
        const newObject = Object.assign({}, el)
        newObject.isActive = true
        return newObject
      })

      if (checkingChanges) {
        this.filterClassesStudentEvent()
      }

    },

    filterRoomEvent () {

      const getUserId = this.roomList.filter(ele => {
        if (ele.isActive) {
          return ele
        }
      }).map(ele => {
        return ele.id
      })
      if (getUserId.length === this.roomList.length) {
        this.allRooms = true
      } else {
        this.allRooms = false
      }

      const payload = {...this.creatingPayload('room'), assets_id:getUserId, course_id:this.room_course_filter_id, class_id:this.room_class_filter_id }

      if (!getUserId.length) {

        this.calendarOptions.events = []
        return true
      }
      this.fetchingEvent(payload, 'room')
    },
    filterTeacherEvent (dateRange = {}, paginate = false) {

      const getUserId = this.teacherList.filter(ele => {
        if (ele.isActive) {
          return ele
        }
      }).map(ele => {
        return ele.id
      })
      /*
       */
      if (getUserId.length === this.teacherList.length) {
        this.allTeachers = true
      } else {
        this.allTeachers = false
      }

      const payload = {...this.creatingPayload('teacher'), teacher_id:getUserId, course_id:this.course_filter_id, ...this.filter_payload, dateRange}


      if (!getUserId.length) {

        this.calendarOptions.events = []
        return true
      }
      this.fetchingEvent(payload, 'teacher')
    },
    filterClassesTeacherEvent () {

      const getUserId = this.teacherList.filter(ele => {
        if (ele.isActive) {
          return ele
        }
      }).map(ele => {
        return ele.user.id
      })
      /*
       */
      if (getUserId.length === this.teacherList.length) {
        this.allTeachers = true
      } else {
        this.allTeachers = false
      }

      const payload = {...this.creatingPayload('teacher'), teacher_id:getUserId, class_id:this.class_filter_id}


      if (!getUserId.length) {

        this.calendarOptions.events = []
        return true
      }
      this.fetchingEvent(payload, 'teacher_classes')
    },
    filterAllTeacher () {

      this.teacherList.forEach(ele => {
        ele.isActive = this.allTeachers
      })
      this.filterTeacherEvent()
    },
    filterClassesAllTeacher () {

      this.teacherList.forEach(ele => {
        ele.isActive = this.allTeachers
      })
      this.filterClassesTeacherEvent()
    },
    filterAllRoom () {

      this.roomList.forEach(ele => {
        ele.isActive = this.allRooms
      })
      this.filterRoomEvent()
    },
    filterStudentEvent (dateRange = {}) {

      const getUserId = this.studentList.filter(ele => {
        if (ele.isActive) {
          return ele
        }
      }).map(ele => {
        return ele.client_users.id
      })
      /*
       */
      if (getUserId.length === this.studentList.length) {
        this.allStudents = true
      } else {
        this.allStudents = false
      }


      const payload = {...this.creatingPayload('student'), student_id:getUserId, course_id:this.course_filter_id, ...this.filter_payload, dateRange}


      if (!getUserId.length) {

        this.calendarOptions.events = []
        return true
      }
      this.fetchingEvent(payload, 'student')
    },
    filterClassesStudentEvent () {

      const getUserId = this.studentList.filter(ele => {
        if (ele.isActive) {
          return ele
        }
      }).map(ele => {
        return ele.client_users.id
      })
      /*
       */
      if (getUserId.length === this.studentList.length) {
        this.allStudents = true
      } else {
        this.allStudents = false
      }


      const payload = {...this.creatingPayload('student'), student_id:getUserId, class_id:this.class_filter_id}


      if (!getUserId.length) {

        this.calendarOptions.events = []
        return true
      }
      this.fetchingEvent(payload, 'student_classes')
    },

    filterAllStudent () {
      //
      this.studentList.forEach(ele => {
        ele.isActive = this.allStudents
      })

      this.filterStudentEvent()
    },
    filterClassesAllStudent () {
      //
      this.studentList.forEach(ele => {
        ele.isActive = this.allStudents
      })

      this.filterClassesStudentEvent()
    },

    creatingPayload (type) {
      const year = this.calendarApi.getDate().getFullYear()
      const month = this.calendarApi.getDate().getMonth() + 1  //jan = 0
      const monthString = String(month).padStart(2, 0)  // 0009
      return {
        // user_id: [],
        type,
        year,
        month: monthString
        // type:'teacher'
      }
    },
    nextMonth (type) {

      if (this.$refs.calendar.getApi().currentData.currentViewType === 'dayGridMonth') {
        this.dateRange = {}
      } else if (this.$refs.calendar.getApi().currentData.currentViewType === 'timeGridWeek') {

        const tomorrow = new Date(this.dateRange.end_date)
        tomorrow.setDate(tomorrow.getDate() + 1)

        const firstDay = this.getFirstDayOfWeek(tomorrow)

        const lastDay = new Date(firstDay)
        lastDay.setDate(lastDay.getDate() + 6)

        this.dateRange = { start_date: this.$moment(firstDay).format('YYYY-MM-DD'), end_date: this.$moment(lastDay).format('YYYY-MM-DD') }

      } else if (this.$refs.calendar.getApi().currentData.currentViewType === 'timeGridDay') {

        const date = new Date(this.$refs.calendar.getApi().currentData.currentDate)
        date.setDate(date.getDate() + 1)

        this.dateRange = {start_date: this.$moment(date).format('YYYY-MM-DD'), end_date: this.$moment(date).format('YYYY-MM-DD')}

      }
      this.calendarApi.next()
      let payload = {}
      payload = this.creatingPayload(type)
      payload = {...payload, ...this.filter_payload}
      // this.fetchingEvent(payload, type)
      if (type === 'student') {
        this.filterStudentEvent(this.dateRange)
      } else if (type === 'teacher') {
        this.filterTeacherEvent(this.dateRange)
      } else if (type === 'teacher_classes') {
        this.filterClassesTeacherEvent()
      } else if (type === 'student_classes') {
        this.filterClassesStudentEvent()
      } else if (type === 'room') {
        this.filterRoomEvent()
      } else {
        this.fetchingEvent(payload, type)

      }
    },
    previousMonth (type) {
      this.calendarApi.prev()
      if (this.$refs.calendar.getApi().currentData.currentViewType === 'dayGridMonth') {
        this.dateRange = {}
      } else if (this.$refs.calendar.getApi().currentData.currentViewType === 'timeGridWeek') {

        // const yesterday = new Date(this.dateRange.start_date)
        // yesterday.setDate(yesterday.getDate() - 1)

        // console.log(yesterday)

        const firstDay = this.getFirstDayOfWeek(this.calendarApi.currentDataManager.data.currentDate)
        console.log(firstDay)

        const lastDay = new Date(firstDay)
        lastDay.setDate(lastDay.getDate() + 6)

        this.dateRange = { start_date: this.$moment(firstDay).format('YYYY-MM-DD'), end_date: this.$moment(lastDay).format('YYYY-MM-DD') }


        // const date = new Date(this.dateRange.end_date)
        // date.setDate(date.getDate() - 6)

        // this.dateRange = { start_date: this.$moment(this.dateRange.end_date).format('YYYY-MM-DD'), end_date: this.$moment(date).format('YYYY-MM-DD') }

      } else if (this.$refs.calendar.getApi().currentData.currentViewType === 'timeGridDay') {


        this.dateRange = {start_date: this.$moment(this.calendarApi.currentDataManager.data.currentDate).format('YYYY-MM-DD'), end_date: this.$moment(this.calendarApi.currentDataManager.data.currentDate).format('YYYY-MM-DD')}

      }

      let payload = {}
      payload = this.creatingPayload(type)
      payload = {...payload, ...this.filter_payload}
      if (type === 'student') {
        this.filterStudentEvent(this.dateRange)
      } else if (type === 'teacher') {
        this.filterTeacherEvent(this.dateRange)
      } else if (type === 'teacher_classes') {
        this.filterClassesTeacherEvent()
      } else if (type === 'student_classes') {
        this.filterClassesStudentEvent()
      } else if (type === 'room') {
        this.filterRoomEvent()
      } else {
        this.fetchingEvent(payload, type)

      }


    },
    today (type) {
      console.log(this.calendarApi.currentDataManager.data.viewTitle)

      this.calendarApi.today()
      console.log(this.$refs.calendar.getApi().currentData.currentViewType)
      let payload = {}
      payload = this.creatingPayload(type)
      payload = {...payload, ...this.filter_payload}
      this.dateRange = {start_date: this.$moment(new Date()).format('YYYY-MM-DD'), end_date: this.$moment(new Date()).format('YYYY-MM-DD')}
      // this.fetchingEvent(payload, type)
      if (type === 'student') {
        this.filterStudentEvent(this.dateRange)
      } else if (type === 'teacher') {
        this.filterTeacherEvent(this.dateRange)
      } else if (type === 'teacher_classes') {
        this.filterClassesTeacherEvent()
      } else if (type === 'student_classes') {
        this.filterClassesStudentEvent()
      } else if (type === 'room') {
        this.filterRoomEvent()
      } else {
        this.fetchingEvent(payload, type)

      }
    },
    month (type) {
      this.$refs.calendar.getApi().changeView('dayGridMonth')
      let payload = {}
      payload = this.creatingPayload(type)
      payload = {...payload, ...this.filter_payload}
      console.log(payload)
      // this.fetchingEvent(payload, type)
      if (type === 'student') {
        this.filterStudentEvent()
      } else if (type === 'teacher') {
        this.filterTeacherEvent()
      } else if (type === 'teacher_classes') {
        this.filterClassesTeacherEvent()
      } else if (type === 'student_classes') {
        this.filterClassesStudentEvent()
      } else if (type === 'room') {
        this.filterRoomEvent()
      } else {
        this.fetchingEvent(payload, type)

      }
    },
    week (type) {

      this.$refs.calendar.getApi().changeView('timeGridWeek')

      let payload = {}
      payload = this.creatingPayload(type)
      payload = {...payload, ...this.filter_payload}
      const today = new Date()

      const firstDay = this.getFirstDayOfWeek(today)
      const lastDay = new Date(firstDay)
      lastDay.setDate(lastDay.getDate() + 6)

      this.dateRange = { start_date: this.$moment(firstDay).format('YYYY-MM-DD'), end_date: this.$moment(lastDay).format('YYYY-MM-DD')}
      console.log(payload)
      // this.fetchingEvent(payload, type)
      if (type === 'student') {
        this.filterStudentEvent(this.dateRange)
      } else if (type === 'teacher') {
        this.filterTeacherEvent(this.dateRange)
      } else if (type === 'teacher_classes') {
        this.filterClassesTeacherEvent()
      } else if (type === 'student_classes') {
        this.filterClassesStudentEvent()
      } else if (type === 'room') {
        this.filterRoomEvent()
      } else {
        this.fetchingEvent(payload, type)

      }
    },
    list (type) {

      this.$refs.calendar.getApi().changeView('listWeek')

      let payload = {}
      payload = this.creatingPayload(type)
      payload = {...payload, ...this.filter_payload}
      const today = new Date()

      const firstDay = this.getFirstDayOfWeek(today)
      const lastDay = new Date(firstDay)
      lastDay.setDate(lastDay.getDate() + 6)

      this.dateRange = { start_date: this.$moment(firstDay).format('YYYY-MM-DD'), end_date: this.$moment(lastDay).format('YYYY-MM-DD')}
      console.log(payload)
      // this.fetchingEvent(payload, type)
      if (type === 'student') {
        this.filterStudentEvent(this.dateRange)
      } else if (type === 'teacher') {
        this.filterTeacherEvent(this.dateRange)
      } else if (type === 'teacher_classes') {
        this.filterClassesTeacherEvent()
      } else if (type === 'student_classes') {
        this.filterClassesStudentEvent()
      } else if (type === 'room') {
        this.filterRoomEvent()
      } else {
        this.fetchingEvent(payload, type)

      }
    },
    changeDateFormat (date) {
      let formattedDate = this.$options.filters.dateFormatLocalization(date.start)
      if (date.end) formattedDate += ` - ${this.$options.filters.dateFormatLocalization(date.end)}`
      return formattedDate
    },
    getFirstDayOfWeek (d) {
      // 👇️ clone date object, so we don't mutate it
      const date = new Date(d)
      const day = date.getDay() // 👉️ get day of week

      // 👇️ day of month - day of week (-6 if Sunday), otherwise +1
      const diff = date.getDate() - day + (day === 0 ? -6 : 1)

      return new Date(date.setDate(diff))
    },
    day (type) {
      this.$refs.calendar.getApi().changeView('timeGridDay')
      let payload = {}
      payload = this.creatingPayload(type)
      payload = {...payload, ...this.filter_payload}
      this.dateRange = { start_date: this.$moment(this.$refs.calendar.getApi().getCurrentData().currentDate).format('YYYY-MM-DD'), end_date: this.$moment(this.$refs.calendar.getApi().getCurrentData().currentDate).format('YYYY-MM-DD')}
      console.log(payload)
      // this.fetchingEvent(payload, type)
      if (type === 'student') {
        this.filterStudentEvent(this.dateRange)
      } else if (type === 'teacher') {
        this.filterTeacherEvent(this.dateRange)
      } else if (type === 'teacher_classes') {
        this.filterClassesTeacherEvent()
      } else if (type === 'student_classes') {
        this.filterClassesStudentEvent()
      } else if (type === 'room') {
        this.filterRoomEvent()
      } else {
        this.fetchingEvent(payload, type)

      }
    },
    async fetchingEvent (payloadData = null, type) {
      try {
        this.$vs.loading({
          text:'Fetching Events'
        })
        const customer_id = this.$store.getters.customerId
        let payload = {}
        if (!payloadData) {
          const newDate = new Date()
          const year = newDate.getFullYear()
          const month = newDate.getMonth() + 1  //jan = 0
          const monthString = String(month).padStart(2, 0)  // 0009

          let user_type = type
          if (type === 'teacher_classes' || type === 'teacher') {
            user_type = 'teacher'
          } else if (type === 'student_classes') {
            user_type = 'student'
          } else if (type === 'room') {
            user_type = 'room'
          }

          payload = {
            // user_id: 1,
            type: user_type,
            year,
            month: monthString,
            ...this.filter_payload

          }
        } else {
          payload = payloadData
        }

        if (type === 'cancel') {
          const responseList = await getCancelSchedulerApi(payload, customer_id)
          this.schedulingList = responseList.data.data.schedulelist
        } else if (type === 'room') {
          const responseList = await getRoomSchedulerApi(payload, customer_id)
          this.schedulingList = responseList.data.data.schedules
        } else if (type === 'teacher_classes') {
          const responseList = await classListApi({ ...payload, customer_id })
          this.schedulingList = responseList.data.data.schedules
        } else if (type === 'student_classes') {
          const responseList = await classListApi({ ...payload, customer_id })
          this.schedulingList = responseList.data.data.schedules
        } else {
          const responseList = await getScheduleEventApi(payload, customer_id)
          this.schedulingList = responseList.data.data.schedules
        }


        let scheduleArray = []

        if (type === 'general') {
          scheduleArray = this.schedulingListGeneralSetData(this.schedulingList)

        } else {
          scheduleArray = this.schedulingListSetData(this.schedulingList, type)

        }


        this.eachMonthEventData = scheduleArray
        // this.schedulingList = scheduleArray


        this.calendarOptions.events = scheduleArray

      } catch (error) {} finally {
        this.$vs.loading.close()
      }
    },
    getContrast (hexcolor) {
      //   //
      hexcolor = hexcolor.replace('#', '')
      const r = parseInt(hexcolor.substr(0, 2), 16)
      const g = parseInt(hexcolor.substr(2, 2), 16)
      const b = parseInt(hexcolor.substr(4, 2), 16)
      // eslint-disable-next-line no-mixed-operators
      const yiq = (r * 299 + g * 587 + b * 114) / 1000
      return yiq >= 128 ? '#000000' : '#ffffff'
    },
    validateTodayDate (todayDate, selectedDateParameter) {
      const today = moment(todayDate)
      const selectedDate = moment(selectedDateParameter)


      const differenceDate = today.diff(selectedDate, 'days')
      return differenceDate
    },
    async fetchCourseWithList () {

      try {
        const customer_id = localStorage.getItem('customer_id')
        const {data} = await getCourseWithTeacher(customer_id)

        this.courseList = data.data.course_list

      } catch (error) {

      }
    },
    async getClassShortList () {

      try {
        const customer_id = localStorage.getItem('customer_id')
        const {data} = await getClassShortList(customer_id)

        this.roomClassList = data.data.class_short_list

      } catch (error) {
        //
      }
    },

    async fetchClassWithList () {

      try {
        const customer_id = localStorage.getItem('customer_id')
        const {data} = await getClassListWithoutPagination(customer_id)

        this.classList = data.data.class_short_list

      } catch (error) {
        //
      }
    },
    async filterSchedule (obj, type) {
      this.filter_payload = obj
      let payload = {}
      const getUserId = this.teacherList.filter(ele => {
        if (ele.isActive) {
          return ele
        }
      }).map(ele => {
        return ele.id
      })
      payload = this.creatingPayload(type)
      payload = {...payload, ...this.filter_payload, course_id:this.course_filter_id, teacher_id:getUserId}
      this.fetchingEvent(payload, type)

    }
  }

}

// ReadMe->for All Datatype for Calendar
// id
// String or Integer. Will uniquely identify your event. Useful for getEventById.

// groupId
// String or Integer. Events that share a groupId will be dragged and resized together automatically.

// allDay
// Boolean (true or false). Determines if the event is shown in the “all-day” section of the view, if applicable. Determines if time text is displayed in the event. If this value is not specified, it will be inferred by the start and end properties. See notes below.

// Do not put quotes around this value. That would make it a string, not a boolean.

// start
// Something date-parseable. When your event begins. If your event is explicitly allDay, hour, minutes, seconds and milliseconds will be ignored.

// end
// Something date-parseable. When your event ends. If your event is explicitly allDay, hour, minutes, seconds and milliseconds will be ignored. If omitted, your events will appear to have the default duration. See defaultAllDayEventDuration, defaultTimedEventDuration, and forceEventDuration for more info.

// Note: This value is exclusive. For example, if you have an all-day event that has an end of 2018-09-03, then it will span through 2018-09-02 and end before the start of 2018-09-03.

// daysOfWeek
// Array. (For defining a simple recurring event). The days of the week this event repeats. An array of integers representing days e.g. [0, 1] for an event that repeats on Sundays and Mondays.

// startTime
// Something duration-parseable. (For defining a simple recurring event). The time of day the event starts.

// endTime
// Something duration-parseable. (For defining a simple recurring event). The time of day the event ends.

// startRecur
// Something date-parseable. (For defining a simple recurring event). When recurrences of the event start.

// endRecur
// Something date-parseable. (For defining a simple recurring event). When recurrences of the event end.

// title
// String. The text that will appear on an event.

// url
// String. A URL that will be visited when this event is clicked by the user. For more information on controlling this behavior, see the eventClick callback.

// className or
// classNames
// String or Array. A single string like 'myclass', a space-separated string like 'myclass1 myclass2', or an array of strings like [ 'myclass1', myclass2' ]. Determines which HTML classNames will be attached to the rendered event.

// editable
// Boolean (true or false). Overrides the master editable option for this single event.

// startEditable
// Boolean (true or false). Overrides the master eventStartEditable option for this single event.

// durationEditable
// Boolean (true or false). Overrides the master eventDurationEditable option for this single event.

// resourceEditable
// Boolean (true or false). Overrides the master eventResourceEditable option for this single event. Requires one of the resource plugins.

// resourceId
// String. The string ID of a Resource. See Associating Events with Resources. Requires one of the resource plugins.

// resourceIds
// Array. An array of string IDs of Resources. See Associating Events with Resources. Requires one of the resource plugins.

// display
// Allows alternate rendering of the event, like background events. Can be 'auto' (the default), 'block', 'list-item', 'background', 'inverse-background', or 'none'. See eventDisplay.

// overlap
// Boolean (true or false). Overrides the master eventOverlap option for this single event. If false, prevents this event from being dragged/resized over other events. Also prevents other events from being dragged/resized over this event.

// constraint
// A groupId belonging to other events, "businessHours", or an object. Overrides the master eventConstraint option for this single event.

// color
// String. An alias for specifying the backgroundColor and borderColor at the same time.

// backgroundColor
// Sets an event’s background color just like the calendar-wide eventBackgroundColor option.

// borderColor
// Sets an event’s border color just like the calendar-wide eventBorderColor option.

// textColor
// Sets an event’s text color just like the calendar-wide eventTextColor option.

// rrule
// duration
// These properties are for RRule recurrence.

// daysOfWeek
// startTime
// endTime
// startRecur
// endRecur
// groupId
// These properties are for “simple” recurrence.

// extendedProps
// Object. A plain object with any miscellaneous properties. It will be directly transferred to the extendedProps hash in each Event Object. Often, these props are useful in event render hooks.

// any other property!
// Every other non-standard property will be transferred over to the extendedProps hash in the Event Object. However, it is recommended to explicitly define these in the extendedProps hash.
